import { useApi, asArray } from './useApi'

export interface PoolAccount {
  email: string
  scopes: string[]
  reauthNeeded: boolean
  grantTypes: string[]
}

export function usePool() {
  const { data, loading, error, refetch } = useApi<PoolAccount[]>('/api/data-sources/pool')
  return { accounts: asArray(data), loading, error, refetch }
}
